<!--
  店铺信息
  Lovi 2020-06-19
-->
<template>
  <div class="merchant-info">
    <div class="logo">
      <img v-if="data.logo" :src="httpUrl + data.logo" />
    </div>
    <div class="info">
      <h1>{{ data.shop_name }}</h1>
      <p class="text-gray cost-info">
        <span>
          {{ $t("life.freeDelivery") }}
          {{ data.starting_price }}P
        </span>
        <span>
          {{ $t("life.deliveryFee") }}
          {{ data.delivery_fee }}P
        </span>
        <span>
          {{ $t("life.packingFee") }}
          {{ data.packaging_fee }}P
        </span>
      </p>
      <p class="text-gray">{{ $t("life.notice") }}：{{ data.ad_text }}</p>
    </div>
    <div class="coupon">
      <div
        class="item"
        :class="{
          style1: item.coupon_type == 1,
          style2: item.coupon_type == 2,
          disabled: item.is_receive == 1
        }"
        v-for="(item, index) in coupon.coupon"
        :key="index"
      >
        <span class="text-hidden">
          {{ item.coupon_amount }}P {{ item.coupon_name }}
        </span>
        <i></i>
        <span @click="clickReceive(item.is_receive, item.coupon_id)">
          {{
            item.is_receive == 1 ? $t("coupon.received") : $t("coupon.receive")
          }}
        </span>
      </div>
    </div>
    <div class="activity">
      <p class="text-hidden">
        <span v-for="(item, index) in coupon.activity" :key="index">
          {{ item.activity_name }}
        </span>
      </p>
      <span
        class="more text-gray"
        v-if="
          (coupon.coupon && coupon.coupon.length) ||
            (coupon.activity && coupon.activity.length)
        "
        @click="clickMoreCoupon"
      >
        {{ $t("life.moreDiscount") }}<van-icon name="arrow-down" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data", "coupon"],
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    clickMoreCoupon() {
      // 更多优惠券
      this.$emit("update:couponFlag", true);
    },
    clickReceive(isReceive, id) {
      // 领取优惠券
      if (isReceive) {
        return false;
      }
      this.$emit("receiveCoupons", id);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
@images: "~@/assets/images/";
.merchant-info {
  position: relative;
  margin: 10px;
  margin-top: -68px;
  padding: 10px;
  background: #fff;
  line-height: 1.2;
  box-shadow: 0px 4px 10px 0px rgba(154, 200, 255, 0.28);
  border-radius: 8px;
  .logo {
    position: absolute;
    right: 10px;
    top: -10px;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    overflow: hidden;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .info {
    padding-right: 70px;
    h1 {
      font-size: 18px;
      font-weight: 400;
    }
    p {
      margin-top: 5px;
    }
    .cost-info {
      span {
        position: relative;
        margin-right: 5px;
        padding-right: 5px;
        &::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -5px;
          height: 10px;
          border-left: 1.1px solid #9b9b9b;
        }
        &:last-child {
          margin-right: 0;
          padding-right: 0;
          &::after {
            content: normal;
          }
        }
      }
    }
  }

  .coupon {
    display: flex;
    justify-content: flex-start;
    flex-flow: wrap;
    height: 28px;
    overflow: hidden;
    .item {
      margin-top: 5px;
      margin-left: 5px;
      display: flex;
      justify-content: flex-start;
      overflow: hidden;
      &:first-child {
        margin-left: 0;
      }
      &.style1 {
        span {
          background: #ff6d76;
          border-color: #ff6d76;
        }
        i {
          background-image: url("@{images}life/store/style1@2x.png");
        }
        &.disabled {
          span {
            color: #ff6d76;
            background: #ffebec;
            border-color: #ff6d76;
          }
          i {
            background-image: url("@{images}life/store/style1_d@2x.png");
          }
        }
      }
      &.style2 {
        span {
          background: #fe7800;
          border-color: #fe7800;
        }
        i {
          background-image: url("@{images}life/store/style2@2x.png");
        }
        &.disabled {
          span {
            color: #fe7800;
            background: #fff;
            border-color: #fe7800;
          }
          i {
            background-image: url("@{images}life/store/style2_d@2x.png");
          }
        }
      }
      span {
        display: flex;
        align-items: center;
        height: 20px;
        color: #fff;
        background: #ff6d76;
        border: 1.1px solid #ff6d76;
        &:nth-of-type(1) {
          padding-left: 5px;
          border-radius: 4px 0 0 4px;
          border-right: 0;
        }
        &:nth-of-type(2) {
          padding-right: 5px;
          border-left: 0;
          border-radius: 0 4px 4px 0;
        }
        &.text-hidden {
          flex: 1;
        }
      }
      i {
        width: 14px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("@{images}life/store/style1@2x.png");
        background-size: cover;
      }
    }
  }
  .activity {
    padding-top: 5px;
    display: flex;
    justify-content: flex-start;
    line-height: 1;
    p {
      margin-right: 10px;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      span {
        display: flex;
        align-items: center;
        height: 20px;
        margin-right: 5px;
        padding: 0 5px;
        color: #fd4553;
        border: 1.1px solid #fd4553;
        border-radius: 3px;
      }
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      /deep/.van-icon {
        margin-left: 2px;
        font-size: 12px;
      }
    }
  }
}
</style>
